import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Ruid } from "../../common/ruid";
import { BoolValue } from "../../google/protobuf/wrappers";
import { BenchmarkResult } from "./benchmark";
import { Namespace } from "./namespace";
export const protobufPackage = "snapchat.cdp.cof";
export enum ConfigTargetingTriggerEventType {
    UNKNOWN_EVENT_TYPE = 0,
    COLD_START = 1,
    WARM_START = 2,
    FOREGROUND_TRIGGER = 3,
    BACKGROUND_TRIGGER = 4,
    UNRECOGNIZED = -1
}
export enum ConfigTargetingAppState {
    UNKNOWN_APP_STATE = 0,
    FOREGROUND = 1,
    BACKGROUND = 2,
    UNRECOGNIZED = -1
}
export enum ConfigTargetingInstrumentation {
    DEFAULT_INSTRUMENTATION = 0,
    USER_AUTHENTICATION = 1,
    UNRECOGNIZED = -1
}
export interface ConfigTargetingRequest {
    configResultsEtag: string;
    namespaces: Namespace[];
    ghostId: string;
    countryCode: string;
    screenWidth: number;
    screenHeight: number;
    connectivity: Connectivity | undefined;
    maxVideoWidthPx: number;
    maxVideoHeightPx: number;
    benchmarkResults: BenchmarkResult[];
    deltaSync: boolean;
    userAgent: string;
    triggerEventType: ConfigTargetingTriggerEventType;
    appState: ConfigTargetingAppState;
    locale: string;
    deviceId: string;
    userId: string;
    clientIp: string;
    isUnAuthorized: boolean;
    appLocale: string;
    instrumentation: ConfigTargetingInstrumentation;
    lastSuccessfulSync: string;
    isLogout: boolean;
    packageInstaller: string;
    syncTriggerBlizzardSessionId: string;
    syncExecutionBlizzardSessionId: string;
    cofSyncTriggerDelayFromStartupMs: number;
    cofSyncExecutionDelayFromStartupMs: number;
    syncTriggerTime: string;
    decoderEncoderAvailability: DecoderEncoderAvailablity | undefined;
    snapkitAppId: string;
    lenscoreVersion: number;
    ruid: Ruid | undefined;
    configNames: string[];
    includeTestUserTreatments: boolean;
    disableExposureLogging: boolean;
    lensClusterOrig4: number;
    clientId: string;
    propertyOverrides: PropertyOverrides | undefined;
    forLockscreenMode: boolean;
    osBuildVersion: string;
}
export interface PropertyOverrides {
    isWeb: boolean;
}
export interface Connectivity {
    networkType: Connectivity_NetworkType;
    isMetered: boolean | undefined;
    isRoaming: boolean | undefined;
    carrier: string;
}
export enum Connectivity_NetworkType {
    UNKNOWN_NETWORK_TYPE = 0,
    CELLULAR = 1,
    WIFI = 2,
    UNRECOGNIZED = -1
}
export interface DecoderEncoderAvailablity {
    isSnapVp9DecoderAvailable: boolean;
    isSnapAv1DecoderAvailable: boolean;
}
function createBaseConfigTargetingRequest(): ConfigTargetingRequest {
    return {
        configResultsEtag: "",
        namespaces: [],
        ghostId: "",
        countryCode: "",
        screenWidth: 0,
        screenHeight: 0,
        connectivity: undefined,
        maxVideoWidthPx: 0,
        maxVideoHeightPx: 0,
        benchmarkResults: [],
        deltaSync: false,
        userAgent: "",
        triggerEventType: 0,
        appState: 0,
        locale: "",
        deviceId: "",
        userId: "",
        clientIp: "",
        isUnAuthorized: false,
        appLocale: "",
        instrumentation: 0,
        lastSuccessfulSync: "0",
        isLogout: false,
        packageInstaller: "",
        syncTriggerBlizzardSessionId: "",
        syncExecutionBlizzardSessionId: "",
        cofSyncTriggerDelayFromStartupMs: 0,
        cofSyncExecutionDelayFromStartupMs: 0,
        syncTriggerTime: "0",
        decoderEncoderAvailability: undefined,
        snapkitAppId: "",
        lenscoreVersion: 0,
        ruid: undefined,
        configNames: [],
        includeTestUserTreatments: false,
        disableExposureLogging: false,
        lensClusterOrig4: 0,
        clientId: "",
        propertyOverrides: undefined,
        forLockscreenMode: false,
        osBuildVersion: "",
    };
}
export const ConfigTargetingRequest: MessageFns<ConfigTargetingRequest> = {
    encode(message: ConfigTargetingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.configResultsEtag !== "") {
            writer.uint32(10).string(message.configResultsEtag);
        }
        writer.uint32(18).fork();
        for (const v of message.namespaces) {
            writer.int32(v);
        }
        writer.join();
        if (message.ghostId !== "") {
            writer.uint32(26).string(message.ghostId);
        }
        if (message.countryCode !== "") {
            writer.uint32(34).string(message.countryCode);
        }
        if (message.screenWidth !== 0) {
            writer.uint32(40).int32(message.screenWidth);
        }
        if (message.screenHeight !== 0) {
            writer.uint32(48).int32(message.screenHeight);
        }
        if (message.connectivity !== undefined) {
            Connectivity.encode(message.connectivity, writer.uint32(58).fork()).join();
        }
        if (message.maxVideoWidthPx !== 0) {
            writer.uint32(64).int32(message.maxVideoWidthPx);
        }
        if (message.maxVideoHeightPx !== 0) {
            writer.uint32(72).int32(message.maxVideoHeightPx);
        }
        for (const v of message.benchmarkResults) {
            BenchmarkResult.encode(v!, writer.uint32(82).fork()).join();
        }
        if (message.deltaSync !== false) {
            writer.uint32(88).bool(message.deltaSync);
        }
        if (message.userAgent !== "") {
            writer.uint32(98).string(message.userAgent);
        }
        if (message.triggerEventType !== 0) {
            writer.uint32(104).int32(message.triggerEventType);
        }
        if (message.appState !== 0) {
            writer.uint32(112).int32(message.appState);
        }
        if (message.locale !== "") {
            writer.uint32(122).string(message.locale);
        }
        if (message.deviceId !== "") {
            writer.uint32(130).string(message.deviceId);
        }
        if (message.userId !== "") {
            writer.uint32(138).string(message.userId);
        }
        if (message.clientIp !== "") {
            writer.uint32(146).string(message.clientIp);
        }
        if (message.isUnAuthorized !== false) {
            writer.uint32(152).bool(message.isUnAuthorized);
        }
        if (message.appLocale !== "") {
            writer.uint32(162).string(message.appLocale);
        }
        if (message.instrumentation !== 0) {
            writer.uint32(168).int32(message.instrumentation);
        }
        if (message.lastSuccessfulSync !== "0") {
            writer.uint32(176).int64(message.lastSuccessfulSync);
        }
        if (message.isLogout !== false) {
            writer.uint32(184).bool(message.isLogout);
        }
        if (message.packageInstaller !== "") {
            writer.uint32(194).string(message.packageInstaller);
        }
        if (message.syncTriggerBlizzardSessionId !== "") {
            writer.uint32(202).string(message.syncTriggerBlizzardSessionId);
        }
        if (message.syncExecutionBlizzardSessionId !== "") {
            writer.uint32(210).string(message.syncExecutionBlizzardSessionId);
        }
        if (message.cofSyncTriggerDelayFromStartupMs !== 0) {
            writer.uint32(216).int32(message.cofSyncTriggerDelayFromStartupMs);
        }
        if (message.cofSyncExecutionDelayFromStartupMs !== 0) {
            writer.uint32(224).int32(message.cofSyncExecutionDelayFromStartupMs);
        }
        if (message.syncTriggerTime !== "0") {
            writer.uint32(232).int64(message.syncTriggerTime);
        }
        if (message.decoderEncoderAvailability !== undefined) {
            DecoderEncoderAvailablity.encode(message.decoderEncoderAvailability, writer.uint32(242).fork()).join();
        }
        if (message.snapkitAppId !== "") {
            writer.uint32(250).string(message.snapkitAppId);
        }
        if (message.lenscoreVersion !== 0) {
            writer.uint32(256).int32(message.lenscoreVersion);
        }
        if (message.ruid !== undefined) {
            Ruid.encode(message.ruid, writer.uint32(266).fork()).join();
        }
        for (const v of message.configNames) {
            writer.uint32(274).string(v!);
        }
        if (message.includeTestUserTreatments !== false) {
            writer.uint32(288).bool(message.includeTestUserTreatments);
        }
        if (message.disableExposureLogging !== false) {
            writer.uint32(296).bool(message.disableExposureLogging);
        }
        if (message.lensClusterOrig4 !== 0) {
            writer.uint32(304).int32(message.lensClusterOrig4);
        }
        if (message.clientId !== "") {
            writer.uint32(314).string(message.clientId);
        }
        if (message.propertyOverrides !== undefined) {
            PropertyOverrides.encode(message.propertyOverrides, writer.uint32(322).fork()).join();
        }
        if (message.forLockscreenMode !== false) {
            writer.uint32(328).bool(message.forLockscreenMode);
        }
        if (message.osBuildVersion !== "") {
            writer.uint32(338).string(message.osBuildVersion);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): ConfigTargetingRequest {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConfigTargetingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.configResultsEtag = reader.string();
                    continue;
                }
                case 2: {
                    if (tag === 16) {
                        message.namespaces.push(reader.int32() as any);
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.namespaces.push(reader.int32() as any);
                        }
                        continue;
                    }
                    break;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.ghostId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.countryCode = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.screenWidth = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.screenHeight = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.connectivity = Connectivity.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.maxVideoWidthPx = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.maxVideoHeightPx = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.benchmarkResults.push(BenchmarkResult.decode(reader, reader.uint32()));
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.deltaSync = reader.bool();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.userAgent = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.triggerEventType = reader.int32() as any;
                    continue;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.appState = reader.int32() as any;
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.locale = reader.string();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.deviceId = reader.string();
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                }
                case 18: {
                    if (tag !== 146) {
                        break;
                    }
                    message.clientIp = reader.string();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.isUnAuthorized = reader.bool();
                    continue;
                }
                case 20: {
                    if (tag !== 162) {
                        break;
                    }
                    message.appLocale = reader.string();
                    continue;
                }
                case 21: {
                    if (tag !== 168) {
                        break;
                    }
                    message.instrumentation = reader.int32() as any;
                    continue;
                }
                case 22: {
                    if (tag !== 176) {
                        break;
                    }
                    message.lastSuccessfulSync = reader.int64().toString();
                    continue;
                }
                case 23: {
                    if (tag !== 184) {
                        break;
                    }
                    message.isLogout = reader.bool();
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.packageInstaller = reader.string();
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.syncTriggerBlizzardSessionId = reader.string();
                    continue;
                }
                case 26: {
                    if (tag !== 210) {
                        break;
                    }
                    message.syncExecutionBlizzardSessionId = reader.string();
                    continue;
                }
                case 27: {
                    if (tag !== 216) {
                        break;
                    }
                    message.cofSyncTriggerDelayFromStartupMs = reader.int32();
                    continue;
                }
                case 28: {
                    if (tag !== 224) {
                        break;
                    }
                    message.cofSyncExecutionDelayFromStartupMs = reader.int32();
                    continue;
                }
                case 29: {
                    if (tag !== 232) {
                        break;
                    }
                    message.syncTriggerTime = reader.int64().toString();
                    continue;
                }
                case 30: {
                    if (tag !== 242) {
                        break;
                    }
                    message.decoderEncoderAvailability = DecoderEncoderAvailablity.decode(reader, reader.uint32());
                    continue;
                }
                case 31: {
                    if (tag !== 250) {
                        break;
                    }
                    message.snapkitAppId = reader.string();
                    continue;
                }
                case 32: {
                    if (tag !== 256) {
                        break;
                    }
                    message.lenscoreVersion = reader.int32();
                    continue;
                }
                case 33: {
                    if (tag !== 266) {
                        break;
                    }
                    message.ruid = Ruid.decode(reader, reader.uint32());
                    continue;
                }
                case 34: {
                    if (tag !== 274) {
                        break;
                    }
                    message.configNames.push(reader.string());
                    continue;
                }
                case 36: {
                    if (tag !== 288) {
                        break;
                    }
                    message.includeTestUserTreatments = reader.bool();
                    continue;
                }
                case 37: {
                    if (tag !== 296) {
                        break;
                    }
                    message.disableExposureLogging = reader.bool();
                    continue;
                }
                case 38: {
                    if (tag !== 304) {
                        break;
                    }
                    message.lensClusterOrig4 = reader.int32();
                    continue;
                }
                case 39: {
                    if (tag !== 314) {
                        break;
                    }
                    message.clientId = reader.string();
                    continue;
                }
                case 40: {
                    if (tag !== 322) {
                        break;
                    }
                    message.propertyOverrides = PropertyOverrides.decode(reader, reader.uint32());
                    continue;
                }
                case 41: {
                    if (tag !== 328) {
                        break;
                    }
                    message.forLockscreenMode = reader.bool();
                    continue;
                }
                case 42: {
                    if (tag !== 338) {
                        break;
                    }
                    message.osBuildVersion = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<ConfigTargetingRequest>, I>>(base?: I): ConfigTargetingRequest {
        return ConfigTargetingRequest.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<ConfigTargetingRequest>, I>>(object: I): ConfigTargetingRequest {
        const message = createBaseConfigTargetingRequest();
        message.configResultsEtag = object.configResultsEtag ?? "";
        message.namespaces = object.namespaces?.map((e) => e) || [];
        message.ghostId = object.ghostId ?? "";
        message.countryCode = object.countryCode ?? "";
        message.screenWidth = object.screenWidth ?? 0;
        message.screenHeight = object.screenHeight ?? 0;
        message.connectivity = (object.connectivity !== undefined && object.connectivity !== null)
            ? Connectivity.fromPartial(object.connectivity)
            : undefined;
        message.maxVideoWidthPx = object.maxVideoWidthPx ?? 0;
        message.maxVideoHeightPx = object.maxVideoHeightPx ?? 0;
        message.benchmarkResults = object.benchmarkResults?.map((e) => BenchmarkResult.fromPartial(e)) || [];
        message.deltaSync = object.deltaSync ?? false;
        message.userAgent = object.userAgent ?? "";
        message.triggerEventType = object.triggerEventType ?? 0;
        message.appState = object.appState ?? 0;
        message.locale = object.locale ?? "";
        message.deviceId = object.deviceId ?? "";
        message.userId = object.userId ?? "";
        message.clientIp = object.clientIp ?? "";
        message.isUnAuthorized = object.isUnAuthorized ?? false;
        message.appLocale = object.appLocale ?? "";
        message.instrumentation = object.instrumentation ?? 0;
        message.lastSuccessfulSync = object.lastSuccessfulSync ?? "0";
        message.isLogout = object.isLogout ?? false;
        message.packageInstaller = object.packageInstaller ?? "";
        message.syncTriggerBlizzardSessionId = object.syncTriggerBlizzardSessionId ?? "";
        message.syncExecutionBlizzardSessionId = object.syncExecutionBlizzardSessionId ?? "";
        message.cofSyncTriggerDelayFromStartupMs = object.cofSyncTriggerDelayFromStartupMs ?? 0;
        message.cofSyncExecutionDelayFromStartupMs = object.cofSyncExecutionDelayFromStartupMs ?? 0;
        message.syncTriggerTime = object.syncTriggerTime ?? "0";
        message.decoderEncoderAvailability =
            (object.decoderEncoderAvailability !== undefined && object.decoderEncoderAvailability !== null)
                ? DecoderEncoderAvailablity.fromPartial(object.decoderEncoderAvailability)
                : undefined;
        message.snapkitAppId = object.snapkitAppId ?? "";
        message.lenscoreVersion = object.lenscoreVersion ?? 0;
        message.ruid = (object.ruid !== undefined && object.ruid !== null) ? Ruid.fromPartial(object.ruid) : undefined;
        message.configNames = object.configNames?.map((e) => e) || [];
        message.includeTestUserTreatments = object.includeTestUserTreatments ?? false;
        message.disableExposureLogging = object.disableExposureLogging ?? false;
        message.lensClusterOrig4 = object.lensClusterOrig4 ?? 0;
        message.clientId = object.clientId ?? "";
        message.propertyOverrides = (object.propertyOverrides !== undefined && object.propertyOverrides !== null)
            ? PropertyOverrides.fromPartial(object.propertyOverrides)
            : undefined;
        message.forLockscreenMode = object.forLockscreenMode ?? false;
        message.osBuildVersion = object.osBuildVersion ?? "";
        return message;
    },
};
function createBasePropertyOverrides(): PropertyOverrides {
    return { isWeb: false };
}
export const PropertyOverrides: MessageFns<PropertyOverrides> = {
    encode(message: PropertyOverrides, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.isWeb !== false) {
            writer.uint32(8).bool(message.isWeb);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PropertyOverrides {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePropertyOverrides();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.isWeb = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PropertyOverrides>, I>>(base?: I): PropertyOverrides {
        return PropertyOverrides.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PropertyOverrides>, I>>(object: I): PropertyOverrides {
        const message = createBasePropertyOverrides();
        message.isWeb = object.isWeb ?? false;
        return message;
    },
};
function createBaseConnectivity(): Connectivity {
    return { networkType: 0, isMetered: undefined, isRoaming: undefined, carrier: "" };
}
export const Connectivity: MessageFns<Connectivity> = {
    encode(message: Connectivity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.networkType !== 0) {
            writer.uint32(8).int32(message.networkType);
        }
        if (message.isMetered !== undefined) {
            BoolValue.encode({ value: message.isMetered! }, writer.uint32(18).fork()).join();
        }
        if (message.isRoaming !== undefined) {
            BoolValue.encode({ value: message.isRoaming! }, writer.uint32(26).fork()).join();
        }
        if (message.carrier !== "") {
            writer.uint32(34).string(message.carrier);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Connectivity {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectivity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.networkType = reader.int32() as any;
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.isMetered = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.isRoaming = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.carrier = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Connectivity>, I>>(base?: I): Connectivity {
        return Connectivity.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Connectivity>, I>>(object: I): Connectivity {
        const message = createBaseConnectivity();
        message.networkType = object.networkType ?? 0;
        message.isMetered = object.isMetered ?? undefined;
        message.isRoaming = object.isRoaming ?? undefined;
        message.carrier = object.carrier ?? "";
        return message;
    },
};
function createBaseDecoderEncoderAvailablity(): DecoderEncoderAvailablity {
    return { isSnapVp9DecoderAvailable: false, isSnapAv1DecoderAvailable: false };
}
export const DecoderEncoderAvailablity: MessageFns<DecoderEncoderAvailablity> = {
    encode(message: DecoderEncoderAvailablity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.isSnapVp9DecoderAvailable !== false) {
            writer.uint32(8).bool(message.isSnapVp9DecoderAvailable);
        }
        if (message.isSnapAv1DecoderAvailable !== false) {
            writer.uint32(16).bool(message.isSnapAv1DecoderAvailable);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): DecoderEncoderAvailablity {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDecoderEncoderAvailablity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.isSnapVp9DecoderAvailable = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.isSnapAv1DecoderAvailable = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<DecoderEncoderAvailablity>, I>>(base?: I): DecoderEncoderAvailablity {
        return DecoderEncoderAvailablity.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<DecoderEncoderAvailablity>, I>>(object: I): DecoderEncoderAvailablity {
        const message = createBaseDecoderEncoderAvailablity();
        message.isSnapVp9DecoderAvailable = object.isSnapVp9DecoderAvailable ?? false;
        message.isSnapAv1DecoderAvailable = object.isSnapAv1DecoderAvailable ?? false;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
